<template>
  <v-container class="max-width">
    <!-- first card -->
    <v-card :elevation="0">
      <v-toolbar dense flat color="secondary">
        <v-toolbar-title>{{ docTitle }} Preview</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small text :to="backUrl">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <!-- <v-row dense>
          <v-col cols="12">
            <v-btn text>
              <v-icon left color="green">mdi-file-excel</v-icon>Export To Excel
            </v-btn>
            <v-btn text @click="generatePdf">
              <v-icon left color="accent">mdi-printer</v-icon>Print Preview
            </v-btn>
          </v-col>
        </v-row> -->
        <v-divider class="mt-2"></v-divider>
        <v-row>
          <v-col cols="12" md="6">
            <v-row>
              <v-col cols="12" md="7">
                <span class="style-16" style="font-weight: bold">Order Details</span>
                <br />
                <br />
                <span class="style-16">Customer: {{ record.customer && record.customer.Name }}</span>
                <br />
                <div class="style-16">Created By: <span style="color: red">{{ record.user && record.user.name }}</span>
                </div>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" md="6">
            <v-row class="justify-end">
              <v-col cols="12" md="7">
                <span class="style-16" style="float: right">{{ noTitle }}#: {{ record.DocNum }}</span>
                <br />
                <br />
                <span class="style-16" style="float: right">Date: {{ record.CreatedAt | date }}</span>
                <br/>
                <v-btn color="accent" @click="generatePdf" text dark class="float-right mt-2"><v-icon left>mdi-printer</v-icon>Print PDF</v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- end of first card -->

    <!-- no bp card -->
    <v-card class="mt-4" :elevation="0">
      <v-card-text>
        <v-row dense class="subtitle-2 text--primary">
          <v-col cols="12">
            <v-data-table  light dense :items-per-page="100" :headers="headers" :items="orderItems"
              item-key="LineNum"  disable-sort>

              <template v-slot:item.ItemCode="{ item }">
                {{ item.product.ItemCode }}
              </template>

              <template v-slot:item.Name="{ item }">
                <v-text-field 
                  v-if="editMode && editingItem && editingItem.id === item.id" 
                  v-model="editingItem.Name" 
                  dense 
                  outlined
                  @keyup.enter="saveItem"
                  @keyup.esc="cancelEdit"
                ></v-text-field>
                <span v-else>{{ item.Name }}</span>
              </template>

              <template v-slot:item.Quantity="{ item }">
                <v-text-field 
                  v-if="editMode && editingItem && editingItem.id === item.id" 
                  v-model="editingItem.Quantity" 
                  type="number" 
                  dense 
                  outlined
                  @input="updateLineTotal"
                  @keyup.enter="saveItem"
                  @keyup.esc="cancelEdit"
                ></v-text-field>
                <span v-else>{{ item.Quantity }}</span>
              </template>

              <template v-slot:item.Price="{ item }">
                <v-text-field 
                  v-if="editMode && editingItem && editingItem.id === item.id" 
                  v-model="editingItem.Price" 
                  type="number" 
                  dense 
                  outlined
                  @input="updateLineTotal"
                  @keyup.enter="saveItem"
                  @keyup.esc="cancelEdit"
                ></v-text-field>
                <span v-else>{{ item.Price | currency }}</span>
              </template>

              <template v-slot:item.LineTotal="{ item }">
                <span v-if="editMode && editingItem && editingItem.id === item.id">
                  {{ (editingItem.Quantity * editingItem.Price) | currency }}
                </span>
                <span v-else>{{ item.LineTotal | currency }}</span>
              </template>

              <template v-slot:item.actions="{ item }">
                <div v-if="editMode && editingItem && editingItem.id === item.id">
                  <v-btn icon color="green" @click="saveItem" small>
                    <v-icon>mdi-check</v-icon>
                  </v-btn>
                  <v-btn icon color="red" @click="cancelEdit" small>
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </div>
                <div v-else>
                  <v-btn icon color="primary" @click="editItem(item)" small>
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn icon color="red" @click="removeItem(item)" small>
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </div>
              </template>

            </v-data-table>

            <v-row class="mt-2">
              <v-col cols="6">
                <v-btn @click="toggleEditMode" small :color="editMode ? 'red' : 'primary'">
                  <v-icon left>{{ editMode ? 'mdi-close' : 'mdi-pencil' }}</v-icon>
                  {{ editMode ? 'Cancel Edit' : 'Edit Quote' }}
                </v-btn>
              </v-col>
              <v-col cols="6" class="text-right">
                <v-btn v-if="editMode" @click="showAddProductDialog = true" small color="success">
                  <v-icon left>mdi-plus</v-icon>Add Item
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- end of card -->

    <!-- Add totals section -->
    <v-card class="mt-4" :elevation="0">
      <v-card-text>
        <v-row class="justify-end">
          <v-col cols="12" md="4">
            <v-card>
              <v-card-text>
                <v-row dense class="pa-1">
                  <v-col cols="6" class="py-2 font-weight-bold" style="font-size: 1.4em;">Total:</v-col>
                  <v-col cols="6" class="py-2 font-weight-bold" style="font-size: 1.4em;">{{ record.DocTotal | currency }}</v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>


    <v-divider class="mt-2"></v-divider>

    <!-- Add Product Dialog -->
    <v-dialog v-model="showAddProductDialog" max-width="500px">
      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-toolbar-title>Add New Item</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="showAddProductDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="newProduct.Name"
                  label="Product Name"
                  required
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="newProduct.Quantity"
                  label="Quantity"
                  type="number"
                  required
                  outlined
                  @input="updateNewProductTotal"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field
                  v-model="newProduct.Price"
                  label="Unit Price"
                  type="number"
                  required
                  outlined
                  @input="updateNewProductTotal"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  :value="(newProduct.Quantity * newProduct.Price) | currency"
                  label="Line Total"
                  readonly
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="addNewProduct" :disabled="!newProduct.Name || !newProduct.Quantity || !newProduct.Price">
            Add Item
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>

    <!-- pdf preview -->
    <pdf-preview ref="pdfPreview"></pdf-preview>
    <!-- end -->
  </v-container>
</template>

<script>
import { http, host } from "@/common/index";
export default {
  props: {
    docTitle: {
      type: String
    },
    backUrl: {
      type: String
    },
    noTitle: {
      type: String
    },
    initial: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    confirmationDialog: false,
    loader: false,
    record: {},
    pdfUrl: "",
    orderItems: [],
    pageItems: 100,
    editMode: false,
    editingItem: null,
    showAddProductDialog: false,
    newProduct: {
      Name: '',
      Quantity: 1,
      Price: 0
    },
    headers: [
      { text: "Product", value: "name" },
      { text: "Quantity", value: "Quantity" },
      { text: "Unit Price", value: "Price" },
      { text: "Total", value: "LineTotal" },
      { text: "Actions", value: "actions", sortable: false }
    ]
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true
    }
  },
  methods: {
    init(val) {
      this.record = { ...val };
      const products = [];
      if (val.rows) {
        for (const row of val.rows) {
          products.push(row);
        }
        this.orderItems = products;
      }
    },
    generatePdf() {
      var url = "/print-sale-document/" + this.record.id;
      const apiUrl = `${host}${url}`;
      const self = this;
      http.get(apiUrl, { responseType: "blob" }).then(response => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        var fileUrl = URL.createObjectURL(blob);
        self.$refs.pdfPreview.show(fileUrl);
      });
    },
    toggleEditMode() {
      this.editMode = !this.editMode;
      if (!this.editMode) {
        this.cancelEdit();
      }
    },
    editItem(item) {
      this.editingItem = { ...item };
    },
    cancelEdit() {
      this.editingItem = null;
    },
    saveItem() {
      if (!this.editingItem) return;
      
      // Update the item in the array
      const index = this.orderItems.findIndex(item => item.id === this.editingItem.id);
      if (index !== -1) {
        // Calculate new line total
        this.editingItem.LineTotal = parseFloat(this.editingItem.Quantity) * parseFloat(this.editingItem.Price);
        this.orderItems[index] = { ...this.editingItem };
        this.updateQuotationTotal();
        this.saveChangesToServer();
      }
      
      this.editingItem = null;
    },
    removeItem(item) {
      if (confirm('Are you sure you want to remove this item?')) {
        const index = this.orderItems.findIndex(row => row.id === item.id);
        if (index !== -1) {
          this.orderItems.splice(index, 1);
          this.updateQuotationTotal();
          this.saveChangesToServer();
        }
      }
    },
    updateLineTotal() {
      if (this.editingItem) {
        this.editingItem.LineTotal = parseFloat(this.editingItem.Quantity || 0) * parseFloat(this.editingItem.Price || 0);
      }
    },
    updateNewProductTotal() {
      // This is handled by the computed property in the template
    },
    addNewProduct() {
      if (!this.newProduct.Name || !this.newProduct.Quantity || !this.newProduct.Price) return;
      
      const newItem = {
        id: Date.now(), // Simple ID generation
        Name: this.newProduct.Name,
        Quantity: parseFloat(this.newProduct.Quantity),
        Price: parseFloat(this.newProduct.Price),
        LineTotal: parseFloat(this.newProduct.Quantity) * parseFloat(this.newProduct.Price)
      };
      
      this.orderItems.push(newItem);
      this.updateQuotationTotal();
      this.saveChangesToServer();
      
      // Reset form
      this.newProduct = {
        Name: '',
        Quantity: 1,
        Price: 0
      };
      this.showAddProductDialog = false;
    },
    updateQuotationTotal() {
      let total = 0;
      this.orderItems.forEach(item => {
        total += item.LineTotal;
      });
      this.record.DocTotal = total;
    },
    saveChangesToServer() {
      // Prepare data for server update
      const data = {
        DocTotal: this.record.DocTotal,
        rows: this.orderItems.map(item => ({
          id: item.id,
          Name: item.Name,
          Quantity: item.Quantity,
          Price: item.Price,
          LineTotal: item.LineTotal
        }))
      };
      
      const self = this;
      this.$store
        .dispatch("put", { 
          url: `/sale-document-type/${this.record.id}`, 
          data 
        })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.$refs.snackbar.show("Changes saved successfully", "green");
          } else {
            self.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(() => {
          self.$refs.snackbar.show("Error saving changes", "red");
        });
    }
  },
  created() { }
};
</script>

<style lang="scss" scoped>
.genFont {
  font-size: 1.3em;
  font-weight: 500;
}
</style>